import { styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const Row = styled.div`
  display: flex;
  gap: 40px;

  ${getMediaQuery('tablet')} {
    gap: 32px;
  }

  ${getMediaQuery('mobile')} {
    gap: 24px;
  }
`;
